import { GiChickenOven, GiBeerBottle, GiBowlOfRice, GiCupcake, GiIndianPalace, GiCookingPot } from "react-icons/gi";
import { MdOutlineIcecream, MdRamenDining } from "react-icons/md";
import { FaFish, FaBreadSlice, FaFireAlt } from "react-icons/fa";
import { IoRestaurant } from "react-icons/io5";

export const Categories = [
    {
        id: 1,
        name: "All",
        urlParam: 'all',
        icon: <IoRestaurant />,
    },
    {
        id: 2,
        name: "Appetizers",
        urlParam: 'appetizers',
        icon: <FaFireAlt />,
    },
    {
        id: 3,
        name: "Indo Chinese",
        urlParam: 'indo-chinese',
        icon: <MdRamenDining />,
    },
    {
        id: 4,
        name: "South Indian",
        urlParam: 'south-indian',
        icon: <GiIndianPalace />,
    },
    {
        id: 5,
        name: "Entrée",
        urlParam: 'entree',
        icon: <GiCookingPot />,
    },
    {
        id: 6,
        name: "Breads",
        urlParam: 'breads',
        icon: <FaBreadSlice />,
    },
    {
        id: 7,
        name: "Biryanis",
        urlParam: 'biryanis',
        icon: <GiBowlOfRice />,
    },
    {
        id: 8,
        name: "Desserts",
        urlParam: 'desserts',
        icon: <GiCupcake />,
    },
    {
        id: 9,
        name: "Drinks",
        urlParam: 'drinks',
        icon: <GiBeerBottle />,
    },
    {
        id: 10,
        name: "",
        urlParam: '',
        icon: <></>,
    },
    {
        id: 11,
        name: "",
        urlParam: '',
        icon: <></>,
    }
]